import apiClient from './client'

export const instructorsApi = {
  getInstructor: async (id) => {
    const response = await apiClient.get(`/instructors/${id}`)
    return response.data
  },
  getAll: async () => {
    // Get instructors from home API sections
    const response = await apiClient.get('/home')
    const instructorsSection = response.data.data?.sections?.find(s => s.content_type === 'instructors')
    return {
      success: true,
      data: instructorsSection?.content || []
    }
  },
}

